// src/services/normalize.ts

export function pickCodeMessage(input: any): { code?: number; message?: string } {
  const code =
    input?.code ??
    input?.data?.code ??
    input?.data?.data?.code ??
    input?.status?.code ??
    input?.data?.status?.code ??
    input?.data?.data?.status?.code ??
    input?.response?.data?.code ??
    input?.response?.data?.data?.code ??
    input?.response?.data?.status?.code ??
    input?.response?.data?.data?.status?.code;

  const message =
    input?.message ??
    input?.data?.message ??
    input?.data?.data?.message ??
    input?.status?.message ??
    input?.data?.status?.message ??
    input?.data?.data?.status?.message ??
    input?.response?.data?.message ??
    input?.response?.data?.data?.message ??
    input?.response?.data?.status?.message ??
    input?.response?.data?.data?.status?.message;

  return { code, message };
}

export function toError(input: any, fallback = 'Something went wrong'): Error {
  const { code, message } = pickCodeMessage(input);
  if (input instanceof Error) {
    const err: any = input;
    if (code !== undefined && err.code === undefined) err.code = code;
    if (err.payload === undefined) err.payload = (input as any)?.payload ?? input;
    if ((!err.message || err.message === 'Error') && message) err.message = message;
    return err;
  }

  const err: any = new Error(message || fallback);
  if (code !== undefined) err.code = code;
  err.payload = input;
  return err;
}

export function assertOk(input: any, fallback = 'Request failed'): void {
  const { code, message } = pickCodeMessage(input);
  if (Number(code) === 0) return;

  const err: any = toError(input, fallback);
  err.code = code;
  err.payload = input;
  err.message = message || err.message || fallback;
  throw err;
}
